export enum JOB_STATUSES {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
